/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { FormGroup, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function AddProductGroupModal({ title, label, show, handleClose, handleProductGroupInput, newProductGroup, hasError, handleAddProductGroup }) {
  const { t } = useTranslation('common');
  return (
    <Modal className="common-custom-modal modal-medium" show={show} onHide={handleClose}>
      <Modal.Header className="align-items-center">
        <Modal.Title>{title}</Modal.Title>
        <span onClick={handleClose} className="icon-close cursor-pointer ml-auto" />
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner-data">
          <FormGroup>
            <div className="common-input-control">
              <p className="field-name">{label}</p>
              <input type="text" value={newProductGroup} onChange={(e) => handleProductGroupInput(e.target.value)} className="form-control" />
              {hasError && newProductGroup?.trim()?.length === 0 && <div className="error-message d-block">{t('PRODUCT_GROUP.REQUIRED')}</div>}
            </div>
          </FormGroup>
        </div>
        <div className="common-model-footer">
          <button type="button" onClick={() => handleAddProductGroup()} className="btn p-0">
            <span className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddProductGroupModal;
